import React, { useState, useCallback } from 'react';
import { Button } from '@material-ui/core';

import SearchOutlined from '@material-ui/icons/SearchOutlined';
import CloseOutlined from '@material-ui/icons/CloseOutlined';

import classes from './styles.module.scss';

interface SearchBarProp {
  onSearch?: (keyword: string) => void;
  onChange?: (keyword: string) => void;
  defaultValue?: string;
  searchPlaceholder?: string;
}

export default function SearchBar({
  defaultValue,
  searchPlaceholder,
  onSearch = () => {},
  onChange = () => {},
}: SearchBarProp) {
  const [isFocus, setFocus] = useState(false);
  const [handleValue, setHandleValue] = useState(defaultValue || '');

  const isFilled = !!handleValue;

  const onClear = () => {
    setHandleValue('');
    onChange('');
    onSearch('');
  };

  const onSearchBtn = useCallback(() => {
    if (onChange) {
      onChange(handleValue);
    }
    onSearch(handleValue); 
  }, [handleValue, onSearch, onChange]);

  return (
    <div className={classes.searchBarContainer}>
      <Button 
        variant="outlined" color="primary" 
        onClick={onSearchBtn}
        className={classes.searchButton}
      >
        <SearchOutlined />
      </Button>
      <div
        className={[
          classes.search,
          isFocus ? 'focused' : '',
          isFilled ? classes.filled : '',
        ].join(' ')}
      >
        <input
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          placeholder={searchPlaceholder || 'Search'}
          style={{ width: searchPlaceholder ? '17.5rem' : 'unset' }}
          value={handleValue}
          onChange={(e) => setHandleValue(e.target.value)}
        />
        <CloseOutlined onClick={onClear} />
      </div>
    </div>
  );
}
